import { observer } from "mobx-react-lite";
import useNavigateToProperty from '../../hooks/useNavigateToProperty';
import PropertyIcon from '../icons/PropertyIcon';
import styles from '../InfoWithIconAndNavigation.module.css';
import PropertyInfo, { IPropertyInfoProps } from "./PropertyInfo";

function PropertyInfoWithIconAndNavigation({ longitude, latitude, address, city, state, zip, className, onClick }: IPropertyInfoWithIconAndNavigationProps) {
    const navigateToProperty = useNavigateToProperty();

    return (
        <div className={[styles.container, className].join(" ")} onClick={() => {
            onClick && onClick();
            navigateToProperty(longitude, latitude);
        }}>
            <PropertyIcon color="#25479A" className={styles.icon} />
            <PropertyInfo
                address={address}
                city={city}
                state={state}
                zip={zip}
            />
        </div>
    );
}

interface IPropertyInfoWithIconAndNavigationProps extends IPropertyInfoProps {
    longitude: number;
    latitude: number;
}

export default observer(PropertyInfoWithIconAndNavigation);